
.container {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .breadcrumbs {

    ol {
      display: flex;
      gap: 0.5em;
      list-style: none;
      margin: 0;
    }

  }
}